module.exports = __webpack_public_path__ + "img/background.73af60a3.jpg";